"use client";

import { useStrictLocalization } from "@faire/web/common/localization";
import { DismissableTooltip } from "@faire/web/slate/Tooltip";
import ClickOutside from "@faire/web/ui/ClickOutside";
import React, { useState } from "react";
import styled from "styled-components";

import { useSettingEnableUserFeedback } from "@faire/retailer/settings/useSettingEnableUserFeedback";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";

export const SearchUserDrivenFeedbackTooltipClientWrapper: React.FC<
  React.PropsWithChildren<{ index?: number }>
> = ({ children, index }) => {
  const { hasOccurred: hasSeen, setHasOccurred: setHasTooltipSeen } =
    useMilestone("USER_FEEDBACK_TOOLTIP_SEEN");
  const { hasOccurred: hasDismissed, setHasOccurred: setHasTooltipDismissed } =
    useMilestone("USER_FEEDBACK_TOOLTIP_DISMISSED");
  const settingValue = useSettingEnableUserFeedback();
  const { strictLocalize } = useStrictLocalization();
  const [hasClickedOutside, setHasClickedOutside] = useState(false);

  const onDismiss = () => {
    setHasTooltipDismissed();
    setHasTooltipSeen();
  };

  const onClickOutside = () => {
    setHasClickedOutside(true);
    onDismiss();
  };

  if (
    !hasSeen &&
    index === 0 &&
    settingValue &&
    !hasDismissed &&
    !hasClickedOutside
  ) {
    return (
      <ClickOutside onClickOutside={onClickOutside}>
        <StyledWrapper onClick={(e) => e.preventDefault()}>
          <StyledDismissableTooltip
            contents={{
              bodies: [
                strictLocalize({
                  defaultMessage:
                    "New! Hide brand from future recommendations.",
                  description: {
                    text: "A line of text on tooltip says user can use a button to hide a brand from search suggestion.",
                    img: "https://cdn.faire.com/fastly/131b6f580e2f43c4834087bb2f9c7eb3bed851750ffe6f8b93aa5c43ccf0e4d8.png",
                  },
                }),
              ],
            }}
            innerClassName="tooltip-wrapper"
            position="bottom"
            pointerOffset={100}
            onDismiss={onDismiss}
            targetNode={children}
          />
        </StyledWrapper>
      </ClickOutside>
    );
  } else {
    return <>{children}</>;
  }
};

const StyledDismissableTooltip = styled(DismissableTooltip)`
  .tooltip-wrapper {
    cursor: default;
    z-index: 300;
  }
`;

// Since this component is wrapped inside `ProductInfoClientWrapper`, we need this to disable the link cursor behaviour so that user won't be redirected to pdp if they click on the tooltip.
const StyledWrapper = styled.div`
  cursor: default;
`;
